<template>
  <div class="account-page">
    <div class="account-content">
      <div class="login-wrapper login-new">
        <div class="container">
          <div class="login-content user-login">
            <div class="login-logo">
              <img src="@/assets/img/logo.png" alt="img" />
              <router-link to="/dashboard" class="login-logo logo-white">
                <img src="@/assets/img/logo.png" alt="" />
              </router-link>
            </div>
            <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
              <div class="login-userset">
                <div class="login-userheading">
                  <h3>{{ $t('Sign In') }}</h3>
                  <h4>Access the Control panel using your Username and password.</h4>
                </div>
                <div class="form-login">
                  <label class="form-label">Username</label>
                  <div class="form-addons">
                    <Field
                      name="username"
                      type="text"
                      value=""
                      class="form-control"
                      :class="{ 'is-invalid': errors.username }"
                    />
                    <div class="invalid-feedback">{{ errors.username }}</div>
                    <div class="text-danger" id="username"></div>
                    <img src="@/assets/img/icons/mail.svg" alt="img" />
                  </div>
                </div>
                <div class="form-login">
                  <label>Password</label>
                  <div class="pass-group">
                    <Field
                      name="password"
                      :type="showPassword ? 'text' : 'password'"
                      value=""
                      class="form-control pass-input mt-2"
                      :class="{ 'is-invalid': errors.password }"
                    />
                    <span @click="toggleShow" class="toggle-password">
                      <i
                        :class="{
                          'fas fa-eye': showPassword,
                          'fas fa-eye-slash': !showPassword,
                        }"
                      ></i>
                    </span>
                    <div class="invalid-feedback">{{ errors.password }}</div>
                    <div class="emailshow text-danger" id="password"></div>
                  </div>
                </div>
                <div class="form-login authentication-check">
                  <div class="row">
                    <div class="col-6">
                      <div class="custom-control custom-checkbox">
                        <label class="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input type="checkbox" />
                          <!-- <span class="checkmarks"></span>Remember me -->
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-login">
                  <button class="btn btn-login" type="submit">Sign In</button>
                </div>
                <div class="signinform">
                </div>
              </div>
            </Form>
          </div>
          <div
            class="my-4 d-flex justify-content-center align-items-center copyright-text"
          >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { router } from "@/router";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import axios from "axios";

export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      showPassword: false,
      password: null,
      emailError: "",
      passwordError: "",
      isLoading: false,
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
  },
  setup() {
    const schema = Yup.object().shape({
      username: Yup.string().required("Username is required").min(3, "Username must be at least 3 characters"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    });
    const onSubmit = async (values) => {
      document.getElementById("username").innerHTML = "";
      document.getElementById("password").innerHTML = "";
      
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/login`, {
          username: values.username,
          password: values.password,
          app: "ads"
        });

        if (response.data.actk && response.data.reftk) {
          localStorage.setItem('token', response.data.actk);
          localStorage.setItem('refresh-token', response.data.reftk);
          router.push("/dashboard");
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            document.getElementById("password").innerHTML = "Invalid credentials";
          } else if (error.response.data.message) {
            document.getElementById("username").innerHTML = error.response.data.message;
          }
        } else {
          document.getElementById("username").innerHTML = "An error occurred. Please try again.";
        }
      }
    };
    return {
      schema,
      onSubmit,
      checked: ref(false),
    };
  },
};
</script>
